import { endpoints } from 'constants/endpoints';

import { sendRequest } from './sendRequest';

export const getReviewCyclesApi = ({ include_draft }) => {
  const url = endpoints.reviews.reviewCycle.index;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    ...(include_draft ? { queryParams: { include_draft } } : {}),
  });
};

export const archivalReviewCycleApi = ({ formId, isArchive }) => {
  const url = endpoints.reviews.reviewCycle.archival;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      form_id: formId,
      is_archive: isArchive,
    },
  });
};

export const getReviewRatingDetailsApi = ({
  reviewId,
  employeeId,
  providerId,
  isIndividualReviewResult = false,
  responseId,
  providerType,
  isPreview,
  previewSubmissionStatus,
  previewProviderType,
}) => {
  // eslint-disable-next-line no-nested-ternary
  const url = isIndividualReviewResult
    ? endpoints.reviews.ratingDetailsIndividualResult
    : endpoints.reviews.ratingDetails;

  const queryParams = {
    review_id: reviewId,
    emp_id: employeeId,
    previewResponseProviderType: providerType,
    isPreview,
    previewSubmissionStatus,
  };

  if (isIndividualReviewResult) {
    queryParams.responseId = responseId;
    queryParams.previewProviderType = previewProviderType;
  } else {
    queryParams.provider_id = providerId;
  }

  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams,
  });
};

export const getReviewFormRatingDetailsApi = ({ reviewId, employeeId, providerId }) => {
  const url = endpoints.reviews.ratingDetailsFormFilling;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      review_id: reviewId,
      emp_id: employeeId,
      provider_id: providerId,
    },
  });
};

export const getQuestionsApi = ({ limit, offset, label, source }) => {
  const url = endpoints.reviews.question.index;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      label,
      source: source.toUpperCase(),
    },
  });
};

export const getQuestionsWithCustomDescriptionApi = ({ limit, offset, label, source }) => {
  const url = endpoints.reviews.questionsWithCustomDescription;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      limit,
      offset,
      label,
      source: source.toUpperCase(),
    },
  });
};

export const getQuestionByIdApi = ({ questionId }) => {
  const url = endpoints.reviews.question.show(questionId);
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const saveQuestionApi = ({ question, buttonType = false }) => {
  const url = endpoints.reviews.question.index;
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    body: question,
    queryParams: {
      ...(Boolean(buttonType === 'archive' || buttonType === 'unarchived') && {
        isArchive: question?.isArchived,
      }),
    },
  });
};

export const getReviewGoalsTimelineListApi = ({ employeeId }) => {
  const url = endpoints.performanceReview.timelineList;
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
    queryParams: {
      empId: employeeId,
    },
  });
};
